import { UnleashClient } from 'unleash-proxy-client';

export default new UnleashClient({
  url: import.meta.env.VITE_UNLEASH_URL,
  clientKey: import.meta.env.VITE_UNLEASH_SECRET,
  appName: import.meta.env.VITE_UNLEASH_APPNAME,
});
